<template>
  <div>
    <span :class="titleClasses" :data-tooltip="tooltip">{{title}}</span>
    <span v-if="subheading" class="subheading">{{ subheading }}</span>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subheading: {
      type: String,
      required: false,
    },
    tooltip: {
      type: String,
    },
  },
  computed: {
    titleClasses() {
      return {
        'table-title': true,
        'insights-tooltip': this.tooltip,
      };
    },
  },
};
</script>

<style scoped>
.table-title {
  display: flex;
  flex: 0.9;
  margin-bottom: 10px;
  padding-left: 15px;
  text-align: left;
  margin-top: 0;
}

.subheading {
  display: flex;
  color: #778699;
  font-family: Lato;
  font-weight: 400px;
  font-size: 16px;
  text-align: left;
  margin-left: 15px;
  margin-bottom: 16px;
}

.insights-tooltip {
  background: transparent !important;
}
</style>
